export const headers = [
  { field: "id", headerName: "ID", hidden: true },
  {
    field: "pcia_codigo",
    headerName: "Codigo",
    minWidth: 100,
  }, 
  {
    field: "pcia_descripcion",
    headerName: "Descripcion",
    minWidth: 200,
  }, 
  { field: "mostrar", headerName: "Visibilidad", width: 100 },
  ];
  